





























































































































import {Component} from 'vue-property-decorator';
import GenericDistribution from '@/pages/Pages/Distributions/GenericDistribution.vue'
import PushTemplate from '@/pages/Pages/Templates/PushTemplate.vue'
import PushFilters from '@/components/Distributions/PushFilters.vue'
import { MsgTransports } from '@/store/types';
import { Getter } from 'vuex-class';

@Component({components: {GenericDistribution, PushTemplate, PushFilters}})
export default class PushDistribution extends GenericDistribution {

  @Getter("pushOSVersions") pushOSVersionsList: any;
  @Getter("pushSDKVersions") pushSDKVersionsList: any;
  @Getter("pushMappVersions") pushMappVersionsList: any;

  transport = MsgTransports.PUSH

  get applicationName() {
    return this.applicationsList.find((item:any) => item.applicationId == this.template.applicationId)?.appName
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    this.beforeLeave(to,from,next)
  }

  get getOSVersionsNames() {
    return (this.pushOSVersionsList && this.pushOSVersionsList[0])
            ? this.pushOSVersionsList[0]?.versions.filter((item:any) => this.pushFilter.os_version_ids.includes(item.id)).map((item:any) => item.version)
            : []
  }

  get getSDKVersionsNames() {
    return this.pushSDKVersionsList.filter((item:any) => this.pushFilter.sdk_ids.includes(item.id)).map((item:any) => item.version)
  }

  get getMappVersionsNames() {
    return (this.pushMappVersionsList && this.pushMappVersionsList[0])
            ? this.pushMappVersionsList[0]?.versions.filter((item:any) => this.pushFilter.mapp_ids.includes(item.id)).map((item:any) => item.version)
            : []
  }

}
